

const categoryHelper = {


	findInCategoryTree(categoryId, categoryTree) { // FP: Skicka in categoryId och det träd som man vill söka i. 
		//return this.findNode(categoryId, { categoryId: -1, categoryList: categoryTree });

		//const start = performance.now();

		const node = this.findNode(categoryId, categoryTree); // FP-CT 

	

		return node

	},

	/*findNode(categoryId, currentNode) {


		//console.log('FP: findNode: categoryId: ', currentNode.categoryId);

		var i,
			currentChild,
			result;

		if (categoryId == currentNode.categoryId) {
			return currentNode;
		} else {

			if (currentNode.categoryList) {

				for (i = 0; i < currentNode.categoryList.length; i += 1) {

					currentChild = currentNode.categoryList[i];

					// Search in the current child
					result = this.findNode(categoryId, currentChild);

					// Return the result if the node has been found
					if (result !== null) {
						return result;
					}
				}
			}

			return null;
		}
	},*/

	findNode(categoryId, root) { // FP: 2026
		
		
		const stack = [root];

		while (stack.length > 0) {

			const node = stack.pop();

			if (node.categoryId === categoryId) {
			
				return node;
			}

			if (node.categoryList) {

				for (let i = 0; i < node.categoryList.length; i += 1) {
					stack.push(node.categoryList[i]);
				}

			}
		}

		return null;
	},

	getCategoryPath(categoryTree, category) { // FP: Skapar en lista av category-object ur trädet. 

		var list = [];

		//list.push({ name: "Kategorier", categoryList: categoryTree, categoryId: -1 });
		//list.push({ name: "Kategorier", categoryList: categoryTree?.categoryList, categoryId: -1 }); // FP-CT
		list.push(categoryTree); // FP-CT

		if (!category) {
			return list;
		}

		if (category.pathIdList == null) {
			alert("PathIdList is null, ")
			return;
		}

		//const pathIdList = category.pathIdList?.split(";");
		const pathIdList = category.pathIdList

		//alert(category.pathIdList)
		//var currentCategoryNode = categoryTree.find(category => category.categoryId == pathIdList[0])
		var currentCategoryNode = categoryTree?.categoryList?.find(category => category.categoryId == pathIdList[0]) // FP-CT

		if (currentCategoryNode) {
			list.push(currentCategoryNode);
		} else {
			return list;
		}



		//console.log('FP: pathIdList: ', pathIdList);
		//console.log('FP: currentCategoryNode: ', currentCategoryNode);
		//console.log('FP: thisCategory: ', this.category);


		for (var i = 1; i < pathIdList.length; i++) { // loopa alla i path, börja inte på första (för att inte få med root-noden, ex: Boove/Kategorier), start-noden är redan adderad. 

			currentCategoryNode = currentCategoryNode?.categoryList.find(category => category.categoryId == pathIdList[i])

			list.push(currentCategoryNode)

		}

		console.log('FP: getCategoryPath: list: ', list);
		

		return list;

	},

	sumProduct(category){
		return category?.categoryId;
	}




}



export default categoryHelper
